import { createSelector } from "reselect"

import { OwnProps as ContextMenuModalProps } from "./components/ContextMenuModalContent"

import Button = ContextMenu.Button

const getActions = (
    _state: CardView.CardView,
    _props: ContextMenuModalProps,
): Button[] => _props.item.contextMenu?.actions || []

export const getPrimaryActions = createSelector([getActions], (actions) =>
    actions.filter((b: Button) => !b.inOptionalMenu),
)

export const getSecondaryActions = createSelector([getActions], (actions) =>
    actions.filter((b: Button) => b.inOptionalMenu),
)
